var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExistingCustomeractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 168,
    viewBox: "0 0 160 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_500_4021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5683 92.9971C58.2487 92.9971 79.0668 72.179 79.0668 46.4986C79.0668 20.8181 58.2487 0 32.5683 0C6.88782 0 -13.9303 20.8181 -13.9303 46.4986C-13.9303 72.179 6.88782 92.9971 32.5683 92.9971Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.213 174.28V181.798C103.213 184.577 101.079 186.832 98.4559 186.832H-35.2425C-37.8743 186.832 -40 184.577 -40 181.798V121.984C-40 109.092 -30.1353 98.6473 -17.9608 98.6473H19.3724C19.8325 98.6473 20.2466 98.9325 20.4399 99.3835L31.1696 122.251C31.3536 122.628 31.8598 122.628 32.0346 122.251L42.7735 99.3835C42.9576 98.9325 43.3809 98.6473 43.841 98.6473H68.5396C64.4631 106.046 62.1349 114.558 62.1349 123.613C62.1349 148.541 79.7479 169.348 103.213 174.28Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.75 169.476C139.212 169.476 159.844 148.845 159.844 123.392C159.844 97.9295 139.212 77.2982 113.75 77.2982C97.499 77.2982 83.208 85.709 75.0089 98.4264C70.3618 105.613 67.6655 114.19 67.6655 123.392C67.6655 145.164 82.7571 163.412 103.057 168.225C106.489 169.044 110.069 169.476 113.75 169.476ZM114.136 96.6228C118.088 96.6228 121.286 99.8208 121.286 103.772V115.7H133.213C137.165 115.7 140.363 118.898 140.363 122.849C140.363 126.8 137.165 129.998 133.213 129.998H121.286V141.926C121.286 145.877 118.088 149.075 114.136 149.075C110.185 149.075 106.987 145.877 106.987 141.926V129.998H95.0596C91.1082 129.998 87.9102 126.8 87.9102 122.849C87.9102 118.898 91.1082 115.7 95.0596 115.7H106.987V103.772C106.987 99.8208 110.185 96.6228 114.136 96.6228Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_4021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 186.832,
    fill: "white",
    transform: "translate(-40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingCustomeractive);
export default __webpack_public_path__ + "static/media/ExistingCustomeractive.f8cbcd0a02a118ad01f11b2823fa5a8b.svg";
export { ForwardRef as ReactComponent };